export default __webpack_public_path__ + "static/media/ar_MA.93a2afde.svg";